import { StateCreator } from 'zustand';

import { RemoteBoundStoreState } from 'src/store/useRemoteBoundStore';

import { Api } from 'src/models/Api.model';
import { Camera } from 'src/models/Camera.model';
import { GalenDataUser } from 'src/models/GalenData/User.model';
import { Language } from 'src/models/Language.model';
import { Product } from 'src/models/Product.model';
import {
  PracticeSettings,
  Settings,
  UserSettings,
} from 'src/models/Settings.model';

type AuthStateTypes = {
  authInfo: { authToken: string; refreshToken: string };
};

export type CurrentUserStateTypes = {
  currentUser: GalenDataUser | undefined;
};

type LogoType = { logo: string };

type StateTypes = AuthStateTypes & CurrentUserStateTypes & LogoType & Settings;

type ActionsTypes = {
  setAuth: (auth: AuthStateTypes) => void;
  logOut: (reloadPage?: boolean) => void;
  setCurrentUser: (currentUser: CurrentUserStateTypes) => void;
  setLogo: (logo: LogoType) => void;

  setUserSettings: (settings: { userSettings: UserSettings }) => void;

  setPracticeSettings: (settings: {
    practiceSettings: PracticeSettings;
  }) => void;

  setLanguage: (lng: Language) => void;

  setImageFolder: (imageFolder: string | null) => void;
};

export type UserSliceTypes = StateTypes & ActionsTypes & LogoType & Settings;

const initialState: StateTypes = {
  authInfo: {
    authToken: '',
    refreshToken: '',
  },
  currentUser: undefined,
  logo: '',
  userSettings: {
    imageFolder: '',
    canAccessCustomerPortal: false,
    userPermission: {
      read: false,
      print: false,
      create: false,
      list: false,
      update: false,
    },
  },
  practiceSettings: {
    shouldShowGender: false,
    shouldShowHeatmap: false,
    shouldShowCompanyLogo: false,
    logoFile: '',
    broadcast: '',
    watermark: '',
    product: Product.OPTAIN,
    camera: Camera.SMALL,
    hasMfa: false,
  },
};

export const createUserSlice: StateCreator<
  RemoteBoundStoreState,
  [],
  [],
  UserSliceTypes
> = (set, get) => {
  return {
    ...initialState,

    setAuth: (authInfo: AuthStateTypes) => {
      set(authInfo);
    },
    setLogo: (logo: LogoType) => {
      set(logo);
    },

    logOut: (reloadPage: boolean = false) => {
      set(initialState);
      Api.remote.logout(reloadPage);
    },
    setCurrentUser: (currentUser: CurrentUserStateTypes) => {
      set(currentUser);
    },
    setUserSettings(settings) {
      set(settings);
    },

    setPracticeSettings(settings) {
      set(settings);
    },

    setLanguage(lng) {
      const newPracticeSettings = { ...get().practiceSettings, language: lng };
      set({ practiceSettings: newPracticeSettings });
    },

    setImageFolder(imageFolder: string | null) {
      const newUserSettings = { ...get().userSettings, imageFolder };
      set({ userSettings: newUserSettings });
    },
  };
};
